export function usePictureMainColor() {
  //@ts-ignore
  function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

  function getPictureMainColor(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const firstPixel = imageData.data;
          const hexColor = rgbToHex(
            firstPixel[0],
            firstPixel[1],
            firstPixel[2],
          );
          resolve([firstPixel[0], firstPixel[1], firstPixel[2]]);
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  return {
    getPictureMainColor,
  };
}
